import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import useIsFeatureEnabled from 'hooks/useIsFeatureEnabled';
import { FeatureFlag } from 'utils/Constants';

import Profile from './Authentication/Profile';
import NotificationsButton from './Notifications/NotificationsButton';
import { getIsFromGuestServer } from './Workspaces/WorkspacesProvider/utils';

const AuthenticatedHeaderContent = () => {
  const isWorkspacesEnabled = useIsFeatureEnabled(FeatureFlag.WORKFLOWS);
  const { matrixClient } = useMatrixContext({ requireDefinedMatrixClient: false });

  const shouldShowWorkspaces =
    isWorkspacesEnabled && !!matrixClient && !getIsFromGuestServer(matrixClient.getUserId() ?? '');

  return (
    <>
      {shouldShowWorkspaces && <NotificationsButton />}
      <Profile />
    </>
  );
};
export default AuthenticatedHeaderContent;
